import { render, staticRenderFns } from "./proyeksi_anggaran.vue?vue&type=template&id=396faeb8&"
import script from "./proyeksi_anggaran.vue?vue&type=script&lang=js&"
export * from "./proyeksi_anggaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports